import { arnRoleValidator } from '#validation/common/validators';
export const credentialRoleArnValidator = arnRoleValidator('filespace.storageRoleArn.invalid');
